import React from 'react';
import DraftJsEditor from 'components/create/editor';
import { useDraftJsEditorState } from 'hooks/use-draft-js-editor-state';

export const DescriptionInput = ({ description, id, setDescription, placeholder, showVideo, showImage,
    showHeading = true, error }) => {
  const [editorState, getMarkupFromEditorState] = useDraftJsEditorState({ text: description });

  return <DraftJsEditor
    id={id}
    placeholder={placeholder}
    editorState={editorState}
    onEditorStateChange={editor => setDescription(getMarkupFromEditorState(editor))}
    showVideo={showVideo}
    showImage={showImage}
    showHeading={showHeading}
    error={error}
  />
}
